import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { FormControl } from "material-ui/Form";
import MenuItem from "material-ui/Menu/MenuItem";
import Select from "material-ui/Select";
import { addCommas } from "../../../utils/utils";
import moment from "moment";
import { connect } from 'react-redux';
import { hasKLFollowCallBeenEnabled } from '../../../utils/userUtils'

const styles = () => ({
  root: {
    width: '100%',
    background: '#FFFFFF',
    boxShadow: '0px 0px 3px #00000026',
  },

  content: {
    width: '80%',
    display: 'flex',
    margin: 'auto',
    justifyContent: 'space-between',
    padding: 40,
    alignItems: 'baseline',
  },

  selectContent: {
    fontSize: 15,
  },

  flex: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '30px',
    paddingTop: 10,
    alignItems: 'baseline',
    marginLeft: 100,
    fontWeight: 'bold',
  },

  row: {
    display: 'flex',
    alignItems: 'end',
    justifyContent: 'flex-end',
  },

  item: {
    fontSize: 11,
    textAlign: 'end',
  },

  value: {
    fontSize: 17,
  },

  note: {
    marginLeft: '4px',
    fontSize: 11,
  },

  select: {
    color: "black",
    borderBottom: "1px solid #ced4da",
    fontSize: "15px",
    borderWidth: "0",
    height: "33px",
    boxSizing: "border-box",
    padding: "8px 36px 0px 12px",
  },

  summary: {
    display: 'flex',
  },
});

class ResultHeaderSection extends React.Component {
  handleYearChange = (event) => {
    this.props.handleSelectedYearChange(event.target.value);
  };

  handleMonthChange = (event) => {
    this.props.handleSelectedMonthChange(event.target.value);
  };

  // 年の選択肢を生成
  generateYearOptions = () => {
    const { user } = this.props;
    const yearOptions = [];
    const currentYear = new Date().getFullYear()
    // 登録した年までの選択肢を生成する
    const minYear = 2019;
    const startYear = user && user.created_at ? new Date(user.created_at).getFullYear() : minYear;

    for (let year = currentYear; year >= startYear; year--) {
      yearOptions.push({ label: year + '年', value: year.toString() });
    }

    return yearOptions;
  }

  // 月の選択肢を生成
  generateMonthOptions = () => {
    const { user, selectedYear } = this.props;
    const monthOptions = [];
    let startMonth = 1;
    let endMonth = 12;

    if (user && user.created_at && selectedYear === new Date(user.created_at).getFullYear().toString()) {
      // 選択されている年が登録した年の場合は登録した月から生成
      startMonth = new Date(user.created_at).getMonth() + 1;
    }

    const currentDate = new Date();
    if (selectedYear === currentDate.getFullYear().toString()) {
      // 選択されている年が今年の場合は現在の月までを生成
      const currentMonth = currentDate.getMonth() + 1;
      endMonth = currentMonth;
    }

    for (let month = endMonth; month >= startMonth; month--) {
      monthOptions.push({ label: month + '月', value: month.toString() });
    }

    return monthOptions;
  }

  renderSummary = (Month) => {
    const { classes, currentMonthOrdersOverview, selectYearMonthOrdersOverview, isLoadingCurrentMonthOrdersOverview, isLoadingSelectYearMonthOrdersOverview, user } = this.props;
    const summary = Month === '今月' ? currentMonthOrdersOverview : selectYearMonthOrdersOverview;
    const isLoading = Month === '今月' ? isLoadingCurrentMonthOrdersOverview : isLoadingSelectYearMonthOrdersOverview;

    return (
      <div className={classes.flex}>
        <div>
          <div>
            <div className={classes.item}>{Month}のレター注文宛先件数</div>
            <div className={classes.row}>
              <div className={classes.value}>
                {isLoading ? '- ' : summary.letter_order_address_count ? addCommas(summary.letter_order_address_count) : 0}
              </div>
              <div className={classes.note}>件</div>
            </div>
          </div>

          {hasKLFollowCallBeenEnabled(user) && (
            <div style={{ marginTop: 10 }}>
              <div className={classes.item}>{Month}のフォローコール注文宛先件数</div>
              <div className={classes.row}>
                <div className={classes.value}>
                  {isLoading ? '- ' : summary.follow_call_order_address_count ? addCommas(summary.follow_call_order_address_count) : 0}
                </div>
                <div className={classes.note}>件</div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  render() {
    const { classes, selectedYear, selectedMonth, selectedYearMonth, isLoading } = this.props;
    const yearOptions = this.generateYearOptions();
    const monthOptions = this.generateMonthOptions();

    return (
      <div className={classes.root}>
        <div className={classes.content}>
          <div className={classes.selectContent}>
            <FormControl style={{ marginRight: 30 }}>
              <Select
                inputProps={{
                  id: 'year-selector',
                }}
                value={selectedYear}
                onChange={this.handleYearChange}
                classes={{ select: classes.select }}
                style={{ minWidth: 115 }}
                disabled={isLoading}
              >
                {yearOptions.map((year, index) => (
                  <MenuItem key={index} value={year.value}>
                    {year.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl style={{ marginRight: 20 }}>
              <Select
                inputProps={{
                  id: 'month-selector',
                }}
                value={selectedMonth}
                onChange={this.handleMonthChange}
                classes={{ select: classes.select }}
                style={{ minWidth: 87 }}
                disabled={isLoading}
              >
                {monthOptions.map((month, index) => (
                  <MenuItem key={index} value={month.value}>
                    {month.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            のデータを表示
          </div>
          <div className={classes.summary}>
            {selectedYearMonth !== moment().format('YYYY-M') && (
              this.renderSummary(moment(selectedYearMonth, 'YYYY-M').format('YYYY年M月'))
            )}
            {this.renderSummary('今月')}
          </div>
        </div>
      </div>
    )
  }
}

ResultHeaderSection.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  handleSelectedYearChange: PropTypes.func.isRequired,
  handleSelectedMonthChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  selectedMonth: PropTypes.string,
  selectedYear: PropTypes.string,
  selectedYearMonth: PropTypes.string,
  currentMonthOrdersOverview: PropTypes.object,
  selectYearMonthOrdersOverview: PropTypes.object,
  isLoadingCurrentMonthOrdersOverview: PropTypes.bool,
  isLoadingSelectYearMonthOrdersOverview: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    user: state.accountSetting.user,
  };
};

export default withStyles(styles)(connect(
  mapStateToProps
)(ResultHeaderSection));



// WEBPACK FOOTER //
// ./src/components/OrderList/sections/ResultHeaderSection.jsx